export enum CommentType {
  text = 'text',
  image = 'image',
  capture = 'capture'
}

export const COMMENT_TEXT_TRANSLATION_KEYS = {
  [CommentType.text]: 'liveforms-editor.comment-item.default-text.text',
  [CommentType.image]: 'liveforms-editor.comment-item.default-text.image',
  [CommentType.capture]: 'liveforms-editor.comment-item.default-text.capture'
};

export const DEFAULT_COMMENT_TEXT = {
  [CommentType.text]: '&lt;Kommentar durch Doppelklick bearbeiten&gt;',
  [CommentType.image]: '',
  [CommentType.capture]: 'Foto-Kommentar'
};
